










import { Component, Vue } from 'vue-property-decorator'

function getCommunityLayoutName ({ route, app }) {
  return route.path.includes('edit') || route.path.includes('new-post') ||
  (app.$device.isMobile && route.path.includes('correspondence') && route.params.user) ||
  (app.$device.isMobile && route.path.includes('message-to-moderator'))
    ? 'empty'
    : 'default'
}

@Component({
  name: 'CommunityBasePage',
  validate ({ params }) {
    return ['community', 'consultant'].includes(params.communityType)
  },
  layout: getCommunityLayoutName,
  async asyncData ({ $storeModules, route, params, redirect }) {
    if ($storeModules.community.community?.isConsultant) {
      if (params.communityType === 'community') {
        redirect(
          301,
          route.fullPath.replace('community', 'consultant')
        )
      }
    } else if (params.communityType === 'consultant') {
      redirect(
        301,
        route.fullPath.replace('consultant', 'community')
      )
    }
  }
})
export default class CommunityBasePage extends Vue {
}
